<template>
  <div>
    <el-table
      :data="items"
      size="small"
      class="mt-10"
      v-loading="loading"
      border
    >
      <el-table-column
        align="center"
        :label="category == 2 ? '库存基地 / 钻井' : '发往基地'"
      >
        <template slot-scope="scope">
          {{ scope.row.well.well_number || scope.row.base.name
          }}{{ scope.row.drill_well_id ? '（井）' : '' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="成品分类"
        prop="name"
      ></el-table-column>
      <el-table-column align="center" label="数量" prop="count">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
    category: Number,
  },
}
</script>